import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

const LabelInput = ({
  label, id, value, onChange, onFocus, onBlur, placeholder, inputType,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const swiperContainerRef = useRef(false);

  const handleFocus = () => {
    setIsFocused(true);
    onFocus();
  };

  const handleBlur = () => {
    setIsFocused(false);
    onBlur();
  };

  const renderInput = () => {
    if (inputType === 'textarea') {
      return (
        <textarea
          placeholder={isFocused ? placeholder : ''}
          id={id}
          value={value}
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
      );
    }
    return (
      <input
        placeholder={isFocused ? placeholder : ''}
        type="text"
        id={id}
        value={value}
        onChange={onChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
    );
  };

  return (
    <label ref={swiperContainerRef} htmlFor={id} style={{ position: 'relative', width: '80%' }}>
      <span
        style={{ display: 'block' }}
        className={`${id === 'contactMessage' ? `label-textarea ${isFocused || value ? 'up' : ''}` : `label ${isFocused || value ? 'up' : ''}`}`}
      >
        {label}
      </span>
      {renderInput()}
    </label>
  );
};

LabelInput.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  inputType: PropTypes.oneOf(['input', 'textarea']),
};

LabelInput.defaultProps = {
  inputType: 'input',
};

export default LabelInput;
